<template>
    <Tablet></Tablet>
</template>

<script>
import Tablet from "../../components/ITDepartment/Tablet.vue";
//import AuthLayout from "../../Layouts/AuthLayout.vue";

export default {
    name: "ITDepartment_Tablet",
    components: { Tablet },
};
</script>
